<div class="container" [class.container--no-header]="!header()">
  @if (header()) {
    <h1 class="header">{{ header() }}</h1>
  }
  <tnq-card>
    <div class="card">
      <ng-content></ng-content>
    </div>
  </tnq-card>
</div>
